import {commonService} from "./common.services";

export  const galleryService = {
    getAllGallery,
    saveGallery,
    trackDownload
}

function getAllGallery(data) {

    return commonService.sendHttpRequest('rbuilder/loadgallery', data, "POST");
}

function saveGallery(data) {

    return commonService.sendHttpRequest('rbuilder/savegallery', data, "POST");
}

function trackDownload(data) {

    return commonService.sendHttpRequest('rbuilder/trackdownload', data, "POST");
}


// WEBPACK FOOTER //
// ./src/services/gallery.services.js